module.exports = __webpack_public_path__ + "static/performance2-e70dd01c1839c84ff6e2254d400b5bf0.jpg";